module.exports = __webpack_public_path__ + "img/Want Av Sight 02.53979c84.png";